import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from './routes';
import configureStore from './store';
import AppContainer from './containers/AppContainer';
import ScrollToTop from './components/shared/ScrollToTop';
import AnalyticsListener from './AnalyticsListener';
import TagManager from 'react-gtm-module';
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_KEY,
};
TagManager.initialize(tagManagerArgs);

export const { store } = configureStore();

const App = () => (
  <Provider store={store}>
    <AppContainer>
      <BrowserRouter>
        <AnalyticsListener>
          <AllRoutes />
        </AnalyticsListener>
      </BrowserRouter>
    </AppContainer>
  </Provider>
);

export default App;
